import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, CURRENCIES } from "../lib/api";

const Ctx = createContext(null);
export const useStore = () => useContext(Ctx);

const load = (k, d) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; }
};

export function StoreProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [cart, setCart] = useState(() => load("afrigo_cart", []));
  const [currency, setCurrency] = useState(() => localStorage.getItem("afrigo_cur") || "USD");
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => localStorage.setItem("afrigo_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => localStorage.setItem("afrigo_cur", currency), [currency]);

  const checkAuth = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { setUser(null); }
    finally { setAuthChecked(true); }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setAuthChecked(true); return; }
    checkAuth();
  }, [checkAuth]);

  const signIn = (data) => { if (data.token) localStorage.setItem("afrigo_token", data.token); setUser(data); };
  const signOut = async () => { await api.post("/auth/logout").catch(() => {}); localStorage.removeItem("afrigo_token"); setUser(null); };

  const fmt = (usd) => {
    const c = CURRENCIES[currency];
    const v = usd * c.rate;
    return c.symbol + v.toLocaleString(undefined, { minimumFractionDigits: c.rate > 100 ? 0 : 2, maximumFractionDigits: c.rate > 100 ? 0 : 2 });
  };

  const addToCart = (p, qty = 1) => {
    setCart((c) => {
      const ex = c.find((i) => i.id === p.id);
      if (ex) return c.map((i) => (i.id === p.id ? { ...i, qty: Math.min(i.qty + qty, 50) } : i));
      return [...c, { id: p.id, title: p.title, image: p.image, price_usd: p.price_usd, qty }];
    });
    setCartOpen(true);
  };
  const setQty = (id, qty) => setCart((c) => (qty <= 0 ? c.filter((i) => i.id !== id) : c.map((i) => (i.id === id ? { ...i, qty } : i))));
  const clearCart = () => setCart([]);
  const subtotal = cart.reduce((s, i) => s + i.price_usd * i.qty, 0);
  const count = cart.reduce((s, i) => s + i.qty, 0);

  return (
    <Ctx.Provider value={{ user, authChecked, signIn, signOut, cart, addToCart, setQty, clearCart, subtotal, count,
      currency, setCurrency, fmt, cartOpen, setCartOpen }}>
      {children}
    </Ctx.Provider>
  );
}
